<template lang='pug'>
div
  .c-message.c-message--sm(v-if='isCollapsed')
    .collapsed-message__body.c-message__body.u-weight-bold(@click='isCollapsed = false')
      .collapsed-text(v-text='collapsedText')
      a.collapsed-link
        i.icon-caret-down.u-mrxs
        | View details
  .c-message.expanded-message(v-else, :class="'c-message--' + messageType")
    .c-message__header(v-if='expandedTitle', v-text='expandedTitle')
    .c-message__body.u-weight-bold(v-html='expandedBody')
    button.c-btn.c-btn--inconspicuous.expanded-message__close(@click='isCollapsed = true')
      i.icon-cross

</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'ExpandableMessages',

  props: {
    collapsed: {
      type: Boolean,
      default: false
    },

    messageType: {
      type: String,
      default: 'warn'
    },

    collapsedText: String,

    expandedTitle: String,
    expandedBody: String,

    // 1度目だけ表示させる。2度目以降は Cookie にて折りたたみ表示をする
    expandOnce: {
      type: Boolean,
      default: false
    },

    expandCookieKey: String
  },

  data() {
    return {
      isCollapsed: false
    };
  },

  mounted() {
    this.isCollapsed = this.collapsed;
    if (this.expandOnce) {
      if (!this.expandCookieKey) {
        throw new Error('If expandOnce is true, expandCookieKey must be specified.');
      }

      if (Cookies.get(this.expandCookieKey)) {
        this.isCollapsed = true;
      }
      Cookies.set(this.expandCookieKey, true, {
        path: '/',
        expires: 365
      });
    }
  }
};
</script>

<style scoped>
.collapsed-message__body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.expanded-message {
  position: relative;
}
.expanded-message__close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
